"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var enums_1 = require("../../enums");
var BrowserRichTextParser = /** @class */ (function () {
    function BrowserRichTextParser() {
        this.linkedItemWrapperElem = 'div';
        this.modularContentElementData = {
            type: 'application/kenticocloud',
            dataType: 'data-type',
            dataCodename: 'data-codename'
        };
        this.link = {
            nodeName: 'a',
            dataItemId: 'data-item-id',
        };
    }
    BrowserRichTextParser.prototype.resolveRichTextField = function (html, replacement, config) {
        try {
            var doc = this.createWrapperElement(html);
            // get all linked items
            var result = this.processRichTextField(doc.children, replacement, config, {
                links: [],
                linkedItems: []
            });
            return {
                links: result.links,
                linkedItems: result.linkedItems,
                resolvedHtml: doc.innerHTML
            };
        }
        catch (error) {
            throw Error('Parsing HTML failed:' + error);
        }
    };
    BrowserRichTextParser.prototype.createWrapperElement = function (html) {
        var element = document.createElement(this.linkedItemWrapperElem);
        element.innerHTML = html;
        return element;
    };
    BrowserRichTextParser.prototype.processRichTextField = function (htmlCollection, replacement, config, result) {
        if (!htmlCollection || htmlCollection.length === 0) {
            // there are no more nodes
        }
        else {
            // extract objects
            for (var i = 0; i < htmlCollection.length; i++) {
                var element = htmlCollection[i];
                var typeAttribute = element.attributes ? element.attributes.getNamedItem('type') : undefined;
                if (element.attributes && typeAttribute && typeAttribute.value && typeAttribute.value.toLowerCase() === this.modularContentElementData.type.toLowerCase()) {
                    // node is modular content object
                    var dataCodenameAttribute = element.attributes.getNamedItem(this.modularContentElementData.dataCodename);
                    var dataTypeAttribute = element.attributes.getNamedItem(this.modularContentElementData.dataType);
                    if (!dataTypeAttribute) {
                        throw Error('Missing data type attribute. This is likely an error caused by invalid response.');
                    }
                    var linkItemContentObject = {
                        dataCodename: dataCodenameAttribute ? dataCodenameAttribute.value : '',
                        dataType: dataTypeAttribute ? dataTypeAttribute.value : ''
                    };
                    // add to result
                    result.linkedItems.push(linkItemContentObject);
                    // replace html
                    var parentElement = element.parentElement;
                    if (!parentElement) {
                        console.warn("Could not replace linked item '" + linkItemContentObject.dataCodename + "' of '" + linkItemContentObject.dataType + "' because parent node is undefined. Please report this error if you are seeing this.");
                    }
                    else {
                        // create new element
                        var newElem = document.createElement(config.linkedItemWrapperTag);
                        // get type of resolving item
                        var type = void 0;
                        if (dataTypeAttribute.value === 'item') {
                            type = enums_1.RichTextContentType.Item;
                        }
                        else {
                            throw Error("Unknown data type '" + type + "' found in rich text field.");
                        }
                        newElem.innerHTML = replacement.getLinkedItemHtml(linkItemContentObject.dataCodename, type);
                        // add classes
                        newElem.className = config.linkedItemWrapperClasses.map(function (m) { return m; }).join(' ');
                        // replace original node with new one
                        parentElement.replaceChild(newElem, element);
                    }
                }
                if (element.nodeName.toLowerCase() === this.link.nodeName.toLowerCase()) {
                    var dataItemIdAttribute = element.attributes.getNamedItem(this.link.dataItemId);
                    if (dataItemIdAttribute) {
                        var link = {
                            dataItemId: dataItemIdAttribute ? dataItemIdAttribute.value : ''
                        };
                        // add to result
                        result.links.push(link);
                        // get original link text (the one inside <a> tag)
                        var linkText = element.innerHTML;
                        var linkResult = replacement.getLinkResult(link.dataItemId, linkText);
                        var useResultAsUrl = true;
                        if (typeof linkResult === 'string') {
                            // use result as URL
                            useResultAsUrl = true;
                        }
                        else {
                            useResultAsUrl = false;
                        }
                        if (!useResultAsUrl) {
                            // replace whole link (<a> tag)
                            if (linkResult) {
                                // html for link is defined
                                var linkHtml = linkResult.asHtml;
                                element.outerHTML = linkHtml ? linkHtml : '';
                                var parent_1 = element.parentNode;
                                if (parent_1) {
                                    parent_1.replaceChild(element, element);
                                }
                            }
                        }
                        if (useResultAsUrl) {
                            // add url to link
                            var hrefAttribute = element.attributes.getNamedItem('href');
                            if (!hrefAttribute) {
                                // href attribute is missing
                                if (config.enableAdvancedLogging) {
                                    console.warn("Cannot set url '" + linkResult + "' because 'href' attribute is not present in the <a> tag. Please report this issue if you are seeing this. This warning can be turned off by disabling 'enableAdvancedLogging' option.");
                                }
                            }
                            else {
                                // get link url
                                var linkUrlResult = typeof linkResult === 'string' ? linkResult : linkResult.asUrl;
                                hrefAttribute.value = linkUrlResult ? linkUrlResult : '';
                            }
                        }
                    }
                }
                // recursively process child nodes
                if (element.children && element.children.length > 0) {
                    this.processRichTextField(element.children, replacement, config, result);
                }
            }
        }
        return result;
    };
    return BrowserRichTextParser;
}());
exports.BrowserRichTextParser = BrowserRichTextParser;
//# sourceMappingURL=browser-rich-text.parser.js.map